/** Fill `{key}` placeholders in tenant copy; unknown keys become empty. */
export function interpolateCopy(template: string, values: Record<string, string>): string {
  return template.replace(/\{(\w+)\}/g, (_, key: string) => values[key] ?? '')
}
